// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.modal-content[data-v-2b88ce3c] {\r\n        border-radius: unset;\n}\n.modal-footer[data-v-2b88ce3c] {\r\n        border-top-color: transparent;\n}\n.modal-header[data-v-2b88ce3c] {\r\n        border-top-left-radius: unset;\r\n        border-top-right-radius: unset;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
